import { cva } from "class-variance-authority";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

const labelVariants = cva(
  " font-medium text-cool-gray-600 peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  label: string;
  required?: boolean;
}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, label, required, ...props }, ref) => {
    const { t } = useTranslation();
    return (
      <label ref={ref} className={cn(labelVariants(), className)} {...props}>
        <span>{label}</span>
        {required && (
          <span className="text-xs font-medium text-amber-600"> {t("required")}</span>
        )}
      </label>
    );
  }
);
Label.displayName = "Label";

export { Label };
